import { render, staticRenderFns } from "./CouponSlick.vue?vue&type=template&id=a3a4b324"
import script from "./CouponSlick.vue?vue&type=script&lang=js"
export * from "./CouponSlick.vue?vue&type=script&lang=js"
import style0 from "./CouponSlick.vue?vue&type=style&index=0&id=a3a4b324&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports